/*
 * @Author: fengxiaojing
 * @LastEditTime: 2022-05-11 11:52:06
 * @Description: 二三维标记操作
 * @LastEditors: Please set LastEditors
 */
import qs from 'qs'
import To from 'await-to-js'
import Callback from '@/services/Callback'
import { wizStandardInstance } from './instance'

export default class marker {
  // 保存标记
  static async saveMark(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/two-and-three-dimensional-marking/create', payload)
    )
    return Callback(err, res)
  }
  // 获取标记列表
  static async getList(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(
        `/api/Two_And_Three_Dimensional_Marking/query_list?${qs.stringify(payload)}`
      )
    )
    return Callback(err, res)
  }
  // 获取二维三维标记列表（去重）
  static async getDistinctList(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(
        `/api/Two_And_Three_Dimensional_Marking/query_distinct_list?${qs.stringify(payload)}`
      )
    )
    return Callback(err, res)
  }
  // 删除标记
  static async deleteMark(payload) {
    const [err, res] = await To(
      wizStandardInstance.delete(
        '/api/Two_And_Three_Dimensional_Marking/two_and_three_dimensional_marking',
        {
          data: payload,
        }
      )
    )
    return Callback(err, res)
  }
  // 保存、新增分享记录
  static async addShareMark(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/Two_And_Three_Dimensional_Marking_Share/insert_share', payload)
    )
    return Callback(err, res)
  }
  // 获取历史分享列表
  static async getShareMarkList(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(
        `/api/Two_And_Three_Dimensional_Marking_Share/query_list_share_history?${qs.stringify(
          payload
        )}`
      )
    )
    return Callback(err, res)
  }
  // 删除分享记录
  static async deleteShareMark(payload) {
    const [err, res] = await To(
      wizStandardInstance.delete(
        '/api/Two_And_Three_Dimensional_Marking_Share/two_and_three_dimensional_marking_share',
        {
          data: payload,
        }
      )
    )
    return Callback(err, res)
  }
  // 根据md5获取文件信息
  static async getFileInfoByMd5(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/DocumentFile/getfilecontentasync/${payload}`)
    )
    return Callback(err, res)
  }
}
